import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import RevShareModal from "../../../common/overrides/RevShareModal";
import { Form } from "react-bootstrap";
import { updateAvailableHoursNote } from "../../../../redux/actions/AvailableHoursActions";

class EditNoteModal extends React.Component {
  render() {
    return (
      <RevShareModal
        buttonText="Edit"
        buttonVariant="info"
        modalSize="md"
        title="Add Note"
        yesButtonOnClick={this.onSave}
        yesButtonText="Update"
      >
        <Form>
          <Form.Group>
            <Form.Label>Note</Form.Label>
            <Form.Control
              as="textarea"
              onChange={this.onChange}
              ref={(element) => (this.noteEntry = element)}
              rows="5"
              value={this.state.note.text}
            ></Form.Control>
          </Form.Group>
        </Form>
      </RevShareModal>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      note: { availableHoursId: this.props.availableHoursId, text: this.props.note.text },
    };

    this.onChange = this.onChange.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  onChange() {
    this.setState({
      note: { availableHoursId: this.props.availableHoursId, text: this.noteEntry.value },
    });
  }

  onSave() {
    return this.props.updateAvailableHoursNote(this.props.note.id, this.state.note, this.props.note.availableHoursId);
  }
}

EditNoteModal.propTypes = {
  note: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {};
}

const mapDispatchToProps = {
  updateAvailableHoursNote,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditNoteModal);
